import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import parse from "html-react-parser"
import { StaticImage } from "gatsby-plugin-image"

const Layout = ({ isHomePage, children }) => {
  const {
    wp: {
      generalSettings: { title },
    },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
          description
        }
      }
    }
  `)

  return (
    <div className="global-wrapper" data-is-root-path={isHomePage}>
      <header className="global-header">
        {isHomePage ? (
          <h1 className="main-heading">
            <Link to="/">
              <StaticImage 
                src="../images/gecko-logo-black.png" 
                alt="The Gecko Project Logo" 
                className="header-logo-home"
                loading="eager" 
                />
            </Link>
          </h1>
        ) : (
          <Link className="header-link-home" to="/">
            <StaticImage 
                src="../images/gecko-logo-black.png" 
                alt="The Gecko Project Logo" 
                className="header-logo-small"
                loading="eager" 
                height={50}
                />
          </Link>
        )}
      </header>

      <main>{children}</main>

      <footer>
        {/* © {new Date().getFullYear()}, Built with
        {` `}
        <a href="https://www.gatsbyjs.com">Gatsby</a>
        {` `}
        And <a href="https://wordpress.org/">WordPress</a> */}
      </footer>
    </div>
  )
}

export default Layout
